import React from 'react';
import SongGrid from '../SongGrid';
import strings from './strings';

/**
 * Full-screen song picker opened from the title in the top bar, so a singer
 * can switch songs without leaving the practice shell. Same cards as the
 * home page; a tap goes straight into practice.
 */
const MobileSongSheet = ({ locked, onSelect, onLocalFile, onRequireSignIn, onClose }) => (
  <div className="mps-more mps-songs" role="dialog" aria-label={strings.chooseSong}>
    <header className="mps-topbar sheet">
      <button type="button" className="mps-icon-btn" onClick={onClose} aria-label={strings.close}>&times;</button>
      <div className="mps-title">{strings.chooseSong}</div>
    </header>
    <div className="mps-more-body">
      {locked ? (
        <p className="mps-hint mps-hint-locked">{strings.stopToChangeSong}</p>
      ) : (
        <SongGrid
          hasLoadedSong={false}
          tapToPractice
          onFileLoad={(content, filename) => { onClose(); onSelect(content, filename); }}
          onLocalFileLoad={(file) => { onClose(); onLocalFile(file); }}
          onRequireSignIn={onRequireSignIn}
        />
      )}
    </div>
  </div>
);

export default MobileSongSheet;
